import React from 'react'

const Comment = () => {
  return (
    <div>
         <div className="mb-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="mb-0">Comments</h3>
                </div>
              </div>
            <div className="bg-light rounded p-5">
                <div className="section-title section-title-sm position-relative pb-3 mb-4">
                  <h3 className="mb-0">Leave A Comment</h3>
                </div>
                <form>
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <input type="text" className="form-control bg-white border-0" placeholder="Your Name" style={{height: 55}} />
                    </div>
                    <div className="col-12 col-sm-6">
                      <input type="email" className="form-control bg-white border-0" placeholder="Your Email" style={{height: 55}} />
                    </div>
                    <div className="col-12">
                      <input type="text" className="form-control bg-white border-0" placeholder="Website" style={{height: 55}} />
                    </div>
                    <div className="col-12">
                      <textarea className="form-control bg-white border-0" rows={5} placeholder="Comment" defaultValue={""} />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-primary w-100 py-3" type="submit">Leave Your Comment</button>
                    </div>
                  </div>
                </form>
              </div>
             
    </div>
  )
}

export default Comment